import React from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import AgentViewTable from "./AgentViewTable";
import { CallRowViewModel, NewIndexViewModel } from "../ViewModels/IndexContainerViewModels";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import MonitoringContainer from "../Monitoring/MonitoringContainer";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface IAgentViewContainerProps {
    callRefId: string | null;
    loading: boolean;
    data: NewIndexViewModel;
    searchFailed: boolean;
    handleCallRef: (callRefId: string) => void;
    closeFailedModal: () => void;
    handleFeedbackClose: () => void;
    handleFirestoneFeedbackClose: (customerId: string, date: Date) => void;
    handleChangePage: (event: unknown, newPage: number) => void;
    handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function AgentViewContainer(props: IAgentViewContainerProps) {

    return (
        <Box flex={1} paddingTop="8px" paddingLeft="8px" paddingRight="8px" style={{ overflowY: 'hidden' }} >
            <Dialog
                open={props.searchFailed}
                onClose={props.closeFailedModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Search Failed"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Please try a different filter set.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.closeFailedModal} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={props.callRefId !== null}
                onClose={props.handleFeedbackClose}
                fullScreen
            >
                {props.callRefId !== null &&
                    <MonitoringContainer
                        id={props.callRefId}
                        close={props.handleFeedbackClose}
                        setId={props.handleCallRef}
                        agentView={true}
                        showBackButton={false}
                    />
                }
            </Dialog>
            <Grid container spacing={1} height='100%' style={{ overflowY: 'hidden' }} >
                {props.loading ?
                    <Grid container justifyContent="center" alignItems="center" sx={{ height: "50%" }}>
                        <Grid>
                            <CircularProgress size={50} />
                        </Grid>
                    </Grid>
                    :
                    <Grid size={12} height='100%' style={{ overflowY: 'hidden' }}>
                        <AgentViewTable
                            agentCallRows={props.data.callRows as CallRowViewModel[]}
                            handleFeedbackOpen={props.handleCallRef}
                            handleChangePage={props.handleChangePage}
                            handleChangeRowsPerPage={props.handleChangeRowsPerPage}
                            page={props.data.callTableViewModel.filters.pageNumber}
                            count={props.data.callTableViewModel.filters.count}
                            rowsPerPage={props.data.callTableViewModel.filters.rowsPerPage}
                        />
                    </Grid>
                }
            </Grid>
        </Box>
    );
}